import { useEffect, useState } from "react";
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  LinkedinShareButton,
  FacebookIcon,
  LinkedinIcon,
  WhatsappIcon,
  TwitterIcon,
} from "react-share";

import Banner from "../banner/banner";
import Page from "../page/page";
import ReactGA from "react-ga4";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import tokensImage from "../../assets/jetons.png";

import "./UserPage.scss";
import classNames from "classnames";
import { checkAllowedToBuyNewTokens } from "../OrderSuccessPage/OrderSuccessPage";
import { bindPseudoToCode, ResultType } from "../services/api";
import { doc, getDoc } from "firebase/firestore";

const UserPage = () => {
  const navigate = useNavigate();

  const [allEvents, setAllEvents] = useState([]);
  const [name, setName] = useState("");
  const [currentStep, setCurrentStep] = useState(0);
  const [paymentMethod, setPaymentMethod] = useState("card");
  const [codeFromOperator, setCodeFromOperator] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const initialCheck = async () => {
    const existingCode = window.localStorage.getItem("shotamCode");
    if (existingCode) {
      const allowedToBuy = await checkAllowedToBuyNewTokens(existingCode);
      if (!allowedToBuy) {
        navigate("/order");
      } else {
        window.localStorage.removeItem("shotamCode");
      }
    }
  };

  useEffect(() => {
    const storedName = window.localStorage.getItem("shotamPseudo");
    if (storedName) {
      setName(storedName);
      if (storedName.length >= 3) {
        setCurrentStep(1);
      }
    }
    initialCheck();
    // fetch(
    //   `https://firestore.googleapis.com/v1/projects/shotam-b276d/databases/(default)/documents/events`,
    // )
    //   .then((res) => {
    //     res.json().then((events) => {
    //       // console.log(events);
    //       // setAllEvents(events.documents);
    //       // setAllCities(
    //       //   events.documents
    //       //     .map((event) => event.fields.city.stringValue)
    //       //     .filter((city, index, array) => array.indexOf(city) === index),
    //       // );
    //     });
    //   })
    //   .catch(() => {});
  }, []);

  const handlePseudo = (input) => {
    const newValue = input.target.value;
    setName(newValue);
    window.localStorage.setItem("shotamPseudo", newValue);
    if (newValue.length >= 3) {
      setCurrentStep(1);
    } else {
      setCurrentStep(0);
    }
  };

  const handlePaymentMethod = (type) => {
    setPaymentMethod(type);
  };

  const validateCodeFromOperator = (input) => {
    const code = (input.target.value as string).toUpperCase();
    setCodeFromOperator(code);
    if (code.length === 4) {
      const pseudo = window.localStorage.getItem("shotamPseudo") ?? "Anonymous";
      bindPseudoToCode(pseudo, code).then((result: ResultType) => {
        if (!result.success) {
          setCurrentStep(1);
          setErrorMessage(result.message);
        } else {
          setErrorMessage("");
          setCurrentStep(2);
        }
      });
    }
  };
  return (
    <>
      <Page>
        <div className="buyingStep">
          <div className="stepNumber">1</div>
          <div className="stepTitle">Choisis ton pseudo</div>
          <input
            className="nameInput"
            placeholder="SASUKE"
            onChange={handlePseudo}
            value={name}
          />
        </div>
        <div
          className={classNames(
            "buyingStep",
            currentStep < 1 ? "disabled" : "",
          )}
        >
          <div className="stepNumber">2</div>
          <div className="stepTitle">Achète ton jeton</div>
          {currentStep >= 1 ? (
            <>
              <div className="itemDescription">
                {/* <div className="paymentImage"> */}
                <img src={tokensImage} width={100} height={100} />
                <div className="itemPrice">
                  3<span style={{ fontSize: 28 }}>€</span>
                </div>
                <div className="itemText">
                  <div>
                    1 jeton <span className="separator"> = </span> 3 rounds
                  </div>
                  <div
                    style={{
                      fontSize: 12,
                      transform: "skew(-10deg)",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "flex-start",
                      }}
                    >
                      45s <span className="separator">/</span> Round
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "flex-start",
                      }}
                    >
                      <span className="separator">+</span> 15s de repos !
                    </div>
                  </div>
                </div>
              </div>

              <div className="paymentMethodContainer">
                <button
                  className={classNames(
                    "paymentMethod",
                    "card",
                    paymentMethod === "card" ? "selected" : "",
                  )}
                  onClick={() => handlePaymentMethod("card")}
                >
                  Par carte
                </button>
                <button
                  className={classNames(
                    "paymentMethod",
                    "cash",
                    paymentMethod === "cash" ? "selected" : "",
                  )}
                  onClick={() => handlePaymentMethod("cash")}
                >
                  En espèces
                </button>
              </div>
            </>
          ) : (
            <></>
          )}
          {currentStep >= 1 && paymentMethod == "card" ? (
            //@ts-ignore
            <stripe-buy-button
              style={{ marginTop: 20 }}
              // Test button
              // buy-button-id="buy_btn_1RS2HOQOhdEDTVpRWdYnST3j"
              // publishable-key="pk_test_51RRzL5QOhdEDTVpR9uV9Ldg0Ez0CDC9fXCYxFPQ8I9kIF2djNAlYd7I6URlG28wkkLJ6ytUXjwu8PZ2zTJPsjJ7y00FjmJE3Ym"
              buy-button-id="buy_btn_1RSIvWKKQ9t9erqY8Pal59O4"
              // publishable-key="pk_live_51Qkov7KKQ9t9erqYvLy2cxi85291RpgxR02Ifxyh7hLTeXRjbbDl3Fjy1kfQdmVT72EMgdbyUCjVxKFcKWVv7Gx000A9Pb4Dod"
              publishable-key="pk_live_51Qkov7KKQ9t9erqYvLy2cxi85291RpgxR02Ifxyh7hLTeXRjbbDl3Fjy1kfQdmVT72EMgdbyUCjVxKFcKWVv7Gx000A9Pb4Dod"
            >
              {/* @ts-ignore */}
            </stripe-buy-button>
          ) : (
            <></>
          )}

          {currentStep >= 1 && paymentMethod == "cash" ? (
            <div className="cashInstructions">
              Paie à la caisse, puis valide ton code ici :
              <input
                className="codeInput"
                placeholder="****"
                onChange={validateCodeFromOperator}
                value={codeFromOperator}
              />
              {errorMessage ? (
                <div className="hint">{errorMessage}</div>
              ) : (
                <></>
              )}
            </div>
          ) : (
            <></>
          )}
        </div>
        <div
          className={classNames(
            "buyingStep",
            currentStep < 2 ? "disabled" : "",
          )}
        >
          <div className="stepNumber">3</div>
          <div className="stepTitle">Enfile le casque, et entre ton code</div>
          {codeFromOperator && currentStep >= 2 ? (
            <>
              <div className="code">{codeFromOperator}</div>
              <div className="hint info">
                Lis bien le manuel avant de jouer !
              </div>
            </>
          ) : (
            <></>
          )}
        </div>
      </Page>
    </>
  );
};

export default UserPage;
